// src/config/company.js
// Datos oficiales de BBTS para las páginas legales y de soporte
// (privacidad, términos, contacto y avisos). Meso 360 es un producto de BBTS.

const company = {
  legalName: "BBTS Technology Solutions",
  brand: "BBTS",
  website: "https://bbtspr.com",
  email: "info@bbtspr.com",
  phone: "787-236-9189",
  phoneHref: "tel:+17872369189",
  // WhatsApp Business (Meta / Twilio).
  whatsapp: "+1 555-836-4840",
  whatsappHref: "https://wa.me/15558364840?text=Hola%20BBTS%2C%20necesito%20soporte",
  // Horario de soporte (null oculta la línea).
  supportHours: "8:00 a. m. a 4:00 p. m., hora de Puerto Rico (AST)",
  // Emergencias fuera de horario: solo por WhatsApp.
  emergencyNote: "Emergencias 24/7 por WhatsApp.",
  products: {
    meso360: "Meso 360",
  },
};

export default company;
